export default {
  Vaccine: 'blue.100',
  Treatment: 'purple.100',
}
